import { mergeClasses } from '@fluentui/react-components';

import CardBackgroundContent from 'src/components/atoms/card-background-content/CardBackgroundContent';
import CardBackgroundHeaderBlock from 'src/components/molecules/card-background-header-block/CardBackgroundHeaderBlock';
import CardLayoutContainer from 'src/components/molecules/card-layout-container/CardLayoutContainer';
import { BaseCardLayoutProps, CardHeaderTextProps } from 'src/ui-models/cardLayout';
import { useCardChallengeLayoutStyles } from './CardChallengeLayout.styles';

interface CardChallengeLayoutProps extends BaseCardLayoutProps, CardHeaderTextProps {
  imageUrl: string
}

const CardChallengeLayout: React.FC<CardChallengeLayoutProps> = ({
  imageUrl, headline, body, sectionLabel = '', title = '', caption = '', className,
}) => {
  const styles = useCardChallengeLayoutStyles();
  const fullImageStyle = imageUrl && { backgroundImage: `url(${imageUrl})` };
  const backgroundStyle: React.CSSProperties = fullImageStyle || {};

  const cardHeader = (
    <CardBackgroundHeaderBlock
      sectionLabel={sectionLabel}
      title={title}
      caption={caption}
    />
  );

  return (
    <CardLayoutContainer
      className={mergeClasses('card-challenge-layout', styles.challengeImageBackground, className)}
      style={backgroundStyle}
      header={cardHeader}
      headerClassName={styles.header}
    >
      <CardBackgroundContent headline={headline} body={body} />
    </CardLayoutContainer>
  );
};

export default CardChallengeLayout;
